import axios from 'axios';

const apiUrl = import.meta.env.VITE_SUICH_API_URL;

export const apiClient = axios.create({
  baseURL: apiUrl,
  withCredentials: true, // important for session-based auth (Better Auth)
  headers: {
    'Content-Type': 'application/json',
  },
});

// Global response interceptor
apiClient.interceptors.response.use(
  (response) => response, // success → return as is
  async (error) => {
    if (axios.isAxiosError(error) && error.response?.status === 401) {
      // Unauthorized: session expired or invalid.
      // Dynamic imports keep this module free of circular dependencies
      // with the router/store layer.
      const [{ default: router }, { useAuthStore }] = await Promise.all([
        import('@/router'),
        import('@/stores'),
      ]);
      const auth = useAuthStore();
      auth.handleSessionExpired();

      // Avoid redirect loop (don't redirect if already on login)
      if (router.currentRoute.value.name !== 'login') {
        await router.push({ name: 'login' });
      }
    }
    return Promise.reject(error);
  },
);

export interface PaginatedResult<T> {
  rows: T[];
  count: number;
}

export function useApi() {
  return { axios: async () => apiClient };
}
